import { render } from "./MoveTo.vue?vue&type=template&id=2a77fe3d&scoped=true"
import script from "./MoveTo.vue?vue&type=script&lang=js"
export * from "./MoveTo.vue?vue&type=script&lang=js"

import "./MoveTo.vue?vue&type=style&index=0&id=2a77fe3d&lang=scss&scoped=true"

import exportComponent from "/builds/intratone/interface/intratoneinfov4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a77fe3d"]])

export default __exports__